"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectField = void 0;
require("reflect-metadata");
var DecoratorSymbol_1 = require("./DecoratorSymbol");
/**
 * Decorate a field as a model relation
 *
 * @param constructor
 * @constructor
 */
var ObjectField = function (constructor) {
    return function (Target, property) {
        Object.defineProperty(Target, property, {
            enumerable: true,
            configurable: true,
            get: function () {
                return Reflect.getMetadata(DecoratorSymbol_1.DecoratorSymbol.RAW_VALUE, this, property);
            },
            set: function (value) {
                Object.defineProperty(this, property, {
                    enumerable: true,
                    configurable: false,
                    get: function () {
                        return Reflect.getMetadata(DecoratorSymbol_1.DecoratorSymbol.RAW_VALUE, this, property);
                    },
                    set: function (value) {
                        if (value === null ||
                            value === undefined ||
                            value instanceof Target.constructor) {
                            Reflect.defineMetadata(DecoratorSymbol_1.DecoratorSymbol.RAW_VALUE, value, this, property);
                            return;
                        }
                        var instance;
                        var InstanceConstructor = constructor !== null && constructor !== void 0 ? constructor : Target.constructor;
                        if (typeof InstanceConstructor.create === 'function') {
                            instance = InstanceConstructor.create();
                        }
                        else {
                            instance = new InstanceConstructor();
                        }
                        Object.assign(instance, value);
                        Reflect.defineMetadata(DecoratorSymbol_1.DecoratorSymbol.RAW_VALUE, instance, this, property);
                    }
                });
                this[property] = value;
            }
        });
    };
};
exports.ObjectField = ObjectField;
//# sourceMappingURL=ObjectField.js.map